import {ReloadButton,} from '@flexinet/ui-components';
import {Box,} from '@mantine/core';
import { useQueryClient } from '@tanstack/react-query';
import { usersKeys } from '../hooks/useUsersQuery';

export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({ queryKey: usersKeys.all });
    };

    return (
        <Box mx='sm'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
